export default {"src":"/_next/static/media/DeleteIcon.5e0a2a39.svg","height":14,"width":15,"blurWidth":0,"blurHeight":0};